import { NgModule } from 'ng-metadata/core';
import {PrmResourceRecommender} from './resourceRecommender.directive';
import {ResourceRecommenderService} from './resourceRecommender.service';
import {PrmResourceRecommenderCardContent} from './resourceRecommenderCardContent.directive';
import {PrmResourceRecommenderFullView} from './resourceRecommenderFullView.directive';
import {BannerCardContentService} from "./bannerCardContent.service";
import {PrmBannerCardContent} from "./bannerCardContent.directive";

@NgModule({
    declarations: [
        PrmResourceRecommender,
        PrmResourceRecommenderCardContent,
        PrmResourceRecommenderFullView,
        PrmBannerCardContent
    ],
    providers: [
        ResourceRecommenderService,
        BannerCardContentService
        ]

})
export class ResourceRecommenderModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/resourceRecommender/resourceRecommender.module.ts